import "./styles/globals.css";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { onUnauthorized } from "@/api/client";
import { qk } from "@/api/queries/keys";
import { initRuntime } from "@/api/runtime";
import { createQueryClient, QueryProvider } from "@/app/providers/query-provider";
import { createAppRouter } from "@/app/router";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

async function start() {
  await initRuntime();
  const queryClient = createQueryClient();
  const router = createAppRouter(queryClient);

  // Session expired mid-use: drop to the login page, then come back to where the user was.
  onUnauthorized(() => {
    const { pathname, href } = router.state.location;
    if (pathname === "/login") return;
    queryClient.setQueryData(qk.me(), null);
    void router.navigate({ to: "/login", search: { redirect: href }, replace: true });
  });

  const root = document.getElementById("root");
  if (!root) throw new Error("#root missing");
  createRoot(root).render(
    <StrictMode>
      <QueryProvider client={queryClient}>
        <TooltipProvider delay={300}>
          <RouterProvider router={router} />
        </TooltipProvider>
        <Toaster position="bottom-right" richColors closeButton />
      </QueryProvider>
    </StrictMode>,
  );
}

void start();
